module.exports = __webpack_public_path__ + "media/images/advisor/img_6_1-86562bb11f17911c5324091afea96501.png";